<template>
  <div>
    <v-simple-table>
      <thead>
        <th class="text-left">Nombre</th>
        <th class="text-left">Categoria</th>
      </thead>
      <tbody>
        <template v-for="(item, index) in insumosNoUso">
          <tr :key="index">
            <td>{{ item.Nombre }}</td>
            <td>{{ item.categoria_name}}</td>
          </tr>
        </template>

      </tbody>
    </v-simple-table>
  </div>
</template>

<script>

export default {
  name: "InsumoNoUso",
  components: {},
  props: [],
  data() {
    return {
    }
  },
  methods: {

  },
  computed: {
    insumosNoUso() {
      let products = []
      let prod = this.$store.getters.getProductos;
      prod.forEach((element) => {

        if (element.Tipo == "AYB-Insumo" && !element.Dlat) {
          let existInReceta = false

          prod.forEach((item) => {
            if (item._CatIdx) {
              if (item._CatIdx.includes(element.id)) {
                existInReceta = true
              }
            }
          })
          if (!existInReceta) {
            products.push(element)
          }
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });
      return products


    }
  },
  watch: {},
  beforeMount: function () { },
  mounted() {

  },
};
</script>
